<!-- If detailData exists, display the content -->
@if (detailData?.id) {
  <div class="d-flex flex-row justify-content-between gap-2 p-2">
    <div>
      @if (!detailData?.is_validated) {
        <button
          class="btn btn-sm btn-success"
          (click)="openTemplate(validateCPTemplate)"
        >
          Validate
        </button>
      }
    </div>
    @if (isAdmin) {
      <button
        class="btn btn-sm btn-danger"
        (click)="deleteCheckPoint(detailData)"
      >
        Delete Checkpoint
      </button>
    }
  </div>
  <div class="row row-cols-1 row-cols-lg-2">
    <div class="flex-grow-1">
      <div class="details-card d-flex flex-wrap row-gap-2 column-gap-4 mb-5">
        <dl>
          <dt>Checkpoint Name</dt>
          <dd
            [class.link-edit]="isAdmin && detailData?.is_validated"
            (click)="
              isAdmin && detailData?.is_validated
                ? openTemplate(editCPTemplate)
                : null
            "
          >
            {{ detailData?.name }}
          </dd>
        </dl>
        @if (detailData?.site_id) {
          <dl>
            <dt>Site</dt>
            <dd class="link-view" (click)="redirect('site')">
              {{ detailData?.site }}
              <div class="small">{{ detailData?.company }}</div>
            </dd>
          </dl>
        } @else {
          <dl>
            <div class="d-flex align-items-center mb-3">
              <dt>Client</dt>

              @if (isAdmin) {
                <div
                  (click)="openSiteListTemplate(siteAssignTemplateRef)"
                  class="border rounded small py-1 px-3 ms-2 fw-semibold hover"
                  role="button"
                >
                  Assign Site
                </div>
              }
            </div>
            <dd class="link-view" (click)="redirect('client')">
              {{ detailData?.company }}
            </dd>
          </dl>
        }
        @if (detailData?.description) {
          <dl>
            <dt>Description</dt>
            <dd>
              {{ detailData?.description }}
            </dd>
          </dl>
        }
        @if (detailData?.qr_code) {
          <dl>
            <div class="d-flex gap-3 align-items-center">
              <span>
                <dt>Type</dt>
                <dd>{{ detailData?.is_nfc_code ? "NFC" : "QR" }}</dd>
              </span>

              <span>
                @if (detailData?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt=""
                    class="ms-auto bg-white p-1 rounded"
                    [width]="largeView ? 40 : 30"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt=""
                    class="ms-auto bg-white p-1 rounded"
                    [width]="largeView ? 40 : 30"
                  />
                }
              </span>
            </div>
          </dl>
          <dl>
            <dt>Checkpoint ID</dt>
            <dd>
              <p class="text-break">
                {{
                  detailData?.qr_code.length >= 24
                    ? "......" +
                      detailData?.qr_code.slice(
                        detailData?.qr_code.length - 24,
                        detailData?.qr_code.length
                      )
                    : detailData?.qr_code
                }}
              </p>
            </dd>
          </dl>
        }
        @if (detailData?.is_validated) {
          <dl>
            <dt>
              {{ detailData?.qr_code ? "Location Locked Status" : "Radius" }}
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                class="ms-2"
                [attr.title]="
                  detailData?.qr_code
                    ? 'Scans outside specified radius will be reported.'
                    : 'Scans must be performed inside specified radius.'
                "
              >
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </dt>
            <dd>
              {{
                detailData?.is_locked
                  ? ""
                  : "Not Locked (can be scanned anywhere)"
              }}
              <div>
                @if (isAdmin) {
                  <ng-container>
                    <form [formGroup]="checkPointForm" class="me-3 mt-2">
                      @if (detailData?.qr_code) {
                        <div class="d-flex align-items-center mb-2">
                          <input
                            type="checkbox"
                            name="lockCheckpoint"
                            id="lockCheckpoint"
                            formControlName="is_locked"
                            (change)="
                              updateCheckpointLockValue(editCPLocationTemplate)
                            "
                          /><label class="ms-2 small" for="lockCheckpoint"
                            >Lock Checkpoint</label
                          >
                        </div>
                      }
                      @if (!detailData?.qr_code || detailData?.is_locked) {
                        <div class="d-flex">
                          <div class="flex-grow-1">
                            <div class="form-floating">
                              <input
                                class="form-control"
                                id="description"
                                list="numbers"
                                formControlName="min_distance"
                                type="tel"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                [min]="minKm"
                                placeholder="Geofence Radius (metres)"
                                [max]="maxKm"
                                (focus)="
                                  checkPointForm.controls[
                                    'min_distance'
                                  ].setValue('')
                                "
                                pattern="\d*"
                                [class.is-invalid]="
                                  checkPointForm.controls['min_distance']
                                    .invalid &&
                                  checkPointForm.controls['min_distance']
                                    .touched
                                "
                              /><label for="inputAssignee"
                                >Radius (metres)</label
                              >
                              <datalist id="numbers">
                                @for (number of radiusRangeList; track number) {
                                  <option [value]="number">
                                    {{ number }}
                                  </option>
                                }
                              </datalist>
                            </div>
                          </div>
                          @if (
                            detailData?.min_distance !==
                              checkPointForm.value?.min_distance &&
                            checkPointForm.controls["min_distance"].valid
                          ) {
                            <div class="d-flex align-items-center ms-2">
                              <span (click)="updateGeoDistance()">
                                <button class="btn btn-sm btn-success">
                                  Save
                                </button>
                              </span>
                            </div>
                          }
                        </div>
                      }
                    </form>
                  </ng-container>
                } @else if (detailData?.is_locked) {
                  <dd>
                    <ng-container>
                      {{ detailData?.min_distance | number: "1.0-0" }}
                      metres
                    </ng-container>
                  </dd>
                }
              </div>
            </dd>
          </dl>
        }
        @if (detailData?.user_prompts?.length) {
          <dl>
            <div class="d-flex align-items-center mb-2">
              <div>
                <dt>Mobile Forms</dt>
              </div>
              <div class="d-flex align-items-center">
                @if (isAdmin) {
                  <div
                    (click)="openTemplate(postScanPromptTemplate)"
                    class="border rounded small py-1 px-3 ms-2 fw-semibold hover"
                    role="button"
                  >
                    Add / Remove
                  </div>
                }
              </div>
            </div>
            <dd class="d-flex flex-wrap gap-3">
              @for (prompt of detailData?.user_prompts; track prompt) {
                <div
                  class="p-2 border rounded bg-secondary-subtle d-flex align-items-center justify-content-between gap-3"
                >
                  <i class="fa-solid fa-clipboard-list text-success"></i>
                  <div class="fw-semibold small text-dark">
                    {{ prompt?.name }}
                  </div>
                  @if (isAdmin) {
                    <span (click)="getPromptDetail(prompt)">
                      <i class="fa-solid fa-link text-secondary fs-6"></i>
                    </span>
                  }
                </div>
              }
            </dd>
          </dl>
        }
      </div>

      @if (detailData?.is_validated) {
        <div class="details-card">
          <dl class="d-flex gap-3 flex-wrap">
            @if (detailData?.is_scanned) {
              <button
                class="btn btn-secondary"
                [ngClass]="largeView ? 'btn-sm' : 'btn-md w-100'"
                (click)="onClickScanHistory()"
              >
                Scan History
              </button>
            }
            @if (!detailData?.user_prompts?.length) {
              <button
                class="btn btn-primary"
                [ngClass]="largeView ? 'btn-sm' : 'btn-md w-100'"
                (click)="openTemplate(postScanPromptTemplate)"
              >
                Add Post Scan Mobile Form
              </button>
            }
          </dl>
        </div>
      }
    </div>

    <div class="flex-grow-1">
      <gtapp-map-leaflet
        [latLon]="{
          lat: detailData?.latitude,
          lon: detailData?.longitude,
          geoFenceRadius: detailData?.is_locked ? detailData?.min_distance : '',
        }"
        [mapId]="largeView ? 'mobileMapLargeView' : 'smallMapIdCheckpoint'"
      >
      </gtapp-map-leaflet>
    </div>
  </div>

  @if (largeView) {
    <div>
      <gtapp-gt-table
        [desktopTableUIData]="checkpointHistoryData"
        [desktopTableDetails]="checkpointHistoryTable"
        [otherParams]="{ paginationData: true }"
        (rowClick)="onCPHistoryClick($event)"
      ></gtapp-gt-table>
    </div>
    @if (selectedHistoryEvent) {
      <gtapp-selected-event-detail
        [selectedEvent]="selectedHistoryEvent"
      ></gtapp-selected-event-detail>
    }
  }
}
<!-- Edit Checkpoint Dialog Template (example simplified for clarity) -->
<ng-template #editCPTemplate let-editCPRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Edit Checkpoint
      <span class="float-end" (click)="editCPRef.close(); resetValues()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="checkPointForm">
      @if (currentEditCPStep === 1) {
        <div class="row row-cols-1 g-2">
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                formControlName="name"
                id="cpName"
                type="text"
                [maxlength]="100"
                placeholder="Checkpoint Name"
                autocomplete="off"
              />
              <label for="cpName">Checkpoint Name</label>
            </div>
            @if (checkPointForm.value.name) {
              <span class="input-group-text" (click)="editField('name')">
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              id="description"
              formControlName="description"
              type="text"
              placeholder="Description (Optional)"
            /><label for="inputAssignee">Description (Optional)</label>
          </div>
          @if (detailData?.qr_code) {
            <div class="mt-4 d-flex align-items-center">
              <div class="form-check my-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="is_locked"
                  name="is_locked"
                  formControlName="is_locked"
                  (change)="
                    showAddressLookupForm(
                      checkPointForm.value.is_locked ? 'forward' : 'backward'
                    )
                  "
                />
                <label class="form-check-label small" for="is_locked">
                  Lock Checkpoint
                </label>
              </div>
              <span
                class="ms-2"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="When box is ticked, checkpoint can only be scanned at checkpoint location."
              >
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </div>
          }
        </div>
        <div class="row row-cols-2 mt-4">
          <div>
            <button
              type="button"
              class="btn btn-dark w-100 btn-lg"
              (click)="editCPRef.close(); resetValues()"
            >
              Cancel
            </button>
          </div>
          @if (detailData?.qr_code) {
            @if (checkPointForm.value.is_locked) {
              <div>
                <button
                  type="button"
                  class="btn btn-primary w-100 btn-lg"
                  (click)="showMapTrue(); currentEditCPStep = 2"
                >
                  Update Location
                </button>
              </div>
            }
            @if (!checkPointForm.value.is_locked) {
              <div>
                <button
                  type="button"
                  class="btn btn-primary w-100 btn-lg"
                  (click)="updateCP(checkPointForm)"
                >
                  Update
                </button>
              </div>
            }
          }
          @if (!detailData?.qr_code) {
            <!-- normal checkpoint cases-->
            <div>
              <button
                type="button"
                class="btn btn-primary w-100 btn-lg"
                (click)="showMapTrue(); currentEditCPStep = 2"
              >
                Update Location
              </button>
            </div>
          }
        </div>
      }
      @if (currentEditCPStep === 2) {
        <div class="row row-cols-2 mb-2">
          <div>
            <button
              class="btn btn-dark w-100 btn-lg"
              (click)="showMap = false; currentEditCPStep = 1"
            >
              Back
            </button>
          </div>
          <div>
            <button
              class="btn btn-primary w-100 btn-lg"
              [disabled]="!checkPointForm.valid"
              (click)="updateCP(checkPointForm)"
            >
              Update
            </button>
          </div>
        </div>
        @if (showMap && gps) {
          <div>
            <div class="mb-2">
              <gtapp-address-lookup
                [addressForm]="checkPointForm"
                showLookupFrom="addCheckpoint"
                (updateAddress)="addressSelected($event)"
              >
              </gtapp-address-lookup>
            </div>
            <gtapp-map-leaflet
              [latLon]="gps"
              [mapId]="'checkpointEditmapid'"
              [changableRadius]="true"
              [cursorDraggable]="true"
              (emitData)="emitData($event)"
              (updateMinDistance)="updateMinDistance($event)"
            ></gtapp-map-leaflet>
            <div class="text-center small text-danger">
              Drag the marker to set coordinates
            </div>
          </div>
        }
      }
    </form>
  </div>
</ng-template>
<!--validate checkpoint template-->
<ng-template #validateCPTemplate let-validateCPTemplate="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Validate Checkpoint
      <span
        class="float-end"
        (click)="validateCPTemplate.close(); resetValues()"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="checkPointForm">
      @if (currentValidateStep === 1) {
        <div class="input-group">
          <div class="form-floating">
            <input
              class="form-control"
              formControlName="name"
              id="cpName"
              type="text"
              [maxlength]="100"
              placeholder="Checkpoint Name"
              autocomplete="off"
              (keyup.enter)="
                checkPointForm.value?.name ? (currentValidateStep = 2) : null
              "
            />
            <label for="cpName">Checkpoint Name</label>
          </div>
          @if (checkPointForm.value.name) {
            <span class="input-group-text" (click)="editField('name')">
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
        <div class="mt-4 row row-cols-2">
          <div class="col">
            <button
              class="btn btn-dark btn-lg w-100"
              (click)="validateCPTemplate.close(); resetValues()"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-primary btn-lg w-100"
              (click)="currentValidateStep = 2"
              [disabled]="!checkPointForm.value?.name"
              (click)="showMapTrue()"
            >
              Next
            </button>
          </div>
        </div>
      }
      @if (currentValidateStep === 2) {
        @if (!detailData?.is_validated) {
          <div class="alert alert-danger fs-5" role="alert">
            <small> WARNING: Site cannot be changed once saved</small>
          </div>
        }
        <div class="mb-3">
          @if (checkPointForm.value.site_id) {
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Site</dt>
                    <dd>
                      {{ checkPointForm.value.site }}
                      <div>[{{ checkPointForm.value.company }}]</div>
                    </dd>
                  </div>
                  <div>
                    <span (click)="editField('site')" class="edit-button">
                      <span id="edit-button-placeholder d-none"></span
                    ></span>
                  </div>
                </div>
              </dl>
            </div>
          }
          @if (!checkPointForm.value.site_id) {
            <div>
              <gtapp-auto-complete
                [data]="siteListData"
                placeHolder="Site"
                searchKeyword="company_name"
                [initialValue]="checkPointForm.value.site"
                [itemTemplate]="siteTemplate"
                [addInitialKey]="true"
                (inputChanged)="onSiteSearch($event)"
                (selected)="onSiteSelect($event)"
                inputId="siteId"
                [enableCloseOption]="true"
                (fieldCleared)="editField('site')"
              >
              </gtapp-auto-complete>
            </div>
          }
        </div>
        <ng-template #siteTemplate let-item>
          @if (item?.key === 0) {
            <div>Create New Site</div>
          } @else {
            <div>
              <div class="fw-medium">
                {{ item?.company_name }} [{{ item?.company?.company_name }}]
              </div>
              <div class="small-font text-secondary">
                {{ item?.address?.full_address }}
              </div>
            </div>
          }
        </ng-template>
        <div class="row row-cols-2 mt-4">
          <div class="col">
            <button
              class="btn btn-dark w-100 btn-lg"
              (click)="currentValidateStep = 1"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary w-100 btn-lg"
              [disabled]="!checkPointForm.valid"
              (click)="
                updateCP(checkPointForm, true); validateCPTemplate.close()
              "
            >
              Validate
            </button>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>
<!--Post Scan prompt Tempalte-->
<ng-template #postScanPromptTemplate let-postScanPromptTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Mobile Forms
      <span class="float-end" (click)="postScanPromptTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="p-2 mb-3">
      <div>Select which form(s) to show after the checkpoint scan.</div>
      <div>
        If you select more than one, you can set the order the forms are shown.
      </div>
    </div>

    <ng-container>
      <table class="table table-borderless">
        <tbody
          cdkDropList
          #currentList="cdkDropList"
          [cdkDropListData]="selectedUserPrompts"
          class="drag-drop-container drag-list mt-3"
          (cdkDropListDropped)="drop($event)"
        >
          @for (prompt of availableUserPrompts; track prompt; let i = $index) {
            <tr
              cdkDrag
              [cdkDragDisabled]="!prompt.selected"
              class="cursor-pointer"
              [ngClass]="prompt.selected ? 'cursor-move' : ''"
              (click)="addRemoveUserPrompt(prompt)"
            >
              <td>
                <div class="d-flex align-items-center">
                  @if (prompt.selected && selectedUserPrompts?.length > 1) {
                    <span class="me-2">
                      <i class="fa-solid fa-bars"></i>
                    </span>
                  }

                  @if (prompt.selected) {
                    <div class="pe-2">{{ i + 1 }}.</div>
                  }

                  <div
                    role="button"
                    class="p-2 border rounded bg-secondary-subtle text-dark"
                    [ngClass]="prompt.selected ? 'fw-semibold' : 'opacity-75'"
                  >
                    <i class="fa-solid fa-clipboard-list text-success"></i>
                    <span class="small ms-1">{{ prompt?.name }}</span>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (
        userPromptsTotalPages > 1 &&
        userPromptsTotalCount != availableUserPrompts?.length
      ) {
        <div class="mt-3">
          <button class="btn btn-secondary btn-sm" (click)="onLoadMore()">
            Load More
          </button>
        </div>
      }
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            class="btn btn-dark w-100 btn-lg"
            (click)="postScanPromptTemplate.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary w-100 btn-lg"
            (click)="updateCP(checkPointForm)"
          >
            Update
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
<!--Assign Site to Siteless checkpoints-->
<ng-template #siteAssignTemplateRef let-siteAssignTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Select a site
      <span class="float-end" (click)="siteAssignTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="alert alert-danger fs-5" role="alert">
      <small> WARNING: Site cannot be changed once assigned</small>
    </div>
    <ng-container>
      <div class="input-group mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="filterResults"
            placeholder="Search Site"
            [(ngModel)]="siteLookupFilter"
            (input)="getSitesForAssign(true)"
          />
          <label for="filterResults">Search Site</label>
        </div>
        @if (siteLookupFilter) {
          <span
            class="input-group-text"
            (click)="siteLookupFilter = ''; getSitesForAssign()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      @for (site of siteListForSiteLessCheckpoints; track site) {
        <div>
          <div
            class="rounded shadow p-2 mb-2 cursor-pointer"
            [ngClass]="
              checkPointForm.value?.site_id === site?.id
                ? 'bg-primary'
                : 'border border-secondary'
            "
            (click)="checkPointForm.controls['site_id'].setValue(site?.id)"
          >
            <div>
              {{ site?.company_name }}
            </div>
            <div class="small">
              {{ site?.address?.full_address }}
            </div>
          </div>
        </div>
      }
      @if (
        siteListForSiteLessCheckpointsTotalPages > 1 &&
        siteListForSiteLessCheckpointsTotalCount !=
          siteListForSiteLessCheckpoints?.length
      ) {
        <div class="mt-3">
          <button class="btn btn-secondary btn-lg" (click)="onLoadMoreSites()">
            Load More
          </button>
        </div>
      }
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            class="btn btn-dark w-100 btn-lg"
            (click)="siteAssignTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary w-100 btn-lg"
            [disabled]="!checkPointForm.value?.site_id"
            (click)="updateCP(checkPointForm)"
          >
            Assign
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Edit Checkpoint Dialog Template (example simplified for clarity) -->
<ng-template #editCPLocationTemplate let-editCPLocationRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Confirm Address
      <span
        class="float-end"
        (click)="editCPLocationRef.close(); resetValues()"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="checkPointForm">
      <div class="row row-cols-2 mb-2">
        <div>
          <button
            class="btn btn-dark w-100 btn-lg"
            (click)="editCPLocationRef.close(); resetValues()"
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            class="btn btn-primary w-100 btn-lg"
            [disabled]="
              !checkPointForm.value.latitude ||
              !checkPointForm.value.longitude ||
              !checkPointForm.value.min_distance
            "
            (click)="updateCP(checkPointForm)"
          >
            Update
          </button>
        </div>
      </div>
      <div>
        <div class="mb-2">
          <gtapp-address-lookup
            [addressForm]="checkPointForm"
            showLookupFrom="addCheckpoint"
            (updateAddress)="addressSelected($event)"
          >
          </gtapp-address-lookup>
        </div>
        <gtapp-map-leaflet
          [latLon]="gps"
          [mapId]="
            largeView ? 'checkpointEditmapid' : 'smallMapIdEditCheckpoint'
          "
          [changableRadius]="true"
          [cursorDraggable]="true"
          (emitData)="emitData($event)"
          (updateMinDistance)="updateMinDistance($event)"
        ></gtapp-map-leaflet>
        <div class="text-center small text-danger">
          Drag the marker to set coordinates
        </div>
      </div>
    </form>
  </div>
</ng-template>
